import { useAppFeaturesQuery as e } from "../appConfig/useAppFeaturesQuery.mjs";
import { propertyQueryKeys as t } from "./usePropertiesQueryKeys.mjs";
import { useQueries as n } from "@maat/store-hooks";
import { propertiesApi as r } from "@maat/api-main";
import { useMemo as i } from "react";
//#region src/properties/usePoolRoomsQuery.ts
var a = (a) => {
	let { data: o } = e(), s = o?.multi_unit_enabled === !0, c = n({ queries: a.map((e) => ({
		queryKey: t.property(e),
		queryFn: () => r.getPropertyDetail(e),
		enabled: s,
		retry: !1,
		staleTime: 6e4
	})) });
	return {
		groups: i(() => {
			let e = /* @__PURE__ */ new Map();
			return c.forEach((t, n) => {
				for (let r of t.data?.units ?? []) r.pooled && e.set(r.id, {
					unitId: r.id,
					propertyId: a[n],
					unitName: r.name,
					rooms: r.rooms
				});
			}), e;
		}, [c.map((e) => e.dataUpdatedAt).join(","), a.join(",")]),
		isLoading: s && c.some((e) => e.isLoading)
	};
};
//#endregion
export { a as usePoolRoomsQuery };
